import axios from "axios";

const mocks = {
  "user/me": { GET: { name: "doggo", title: "sir" } }
};

const apiCall = ({ url, method }) =>
  new Promise((resolve, reject) => {
    
    try {
      let api = axios.create({
        baseURL: process.env.VUE_APP_API_HOST,
      });
      
      if (process.env.NODE_ENV == 'production') {
         api.defaults.headers.common['Authorization'] = localStorage.getItem('id_token');
      }
      api.get(url).then(response => {
        resolve(response.data);
      });
    }
    catch (err) {
      reject(new Error(err));
    }
  });

export default apiCall;
